import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export interface AdminUser {
  id: number;
  mobile: string;
  first_name: string;
  last_name: string;
  role: string;
  branch_id: number | null;
  status: string;
}

interface AdminAuthState {
  admin: AdminUser | null;
  isAuthenticated: boolean;

  setAuth: (admin: AdminUser) => void;
  updateAdmin: (patch: Partial<AdminUser>) => void;
  logout: () => void;
}

export const useAdminAuthStore = create<AdminAuthState>()(
  persist(
    (set) => ({
      admin: null,
      isAuthenticated: false,

      setAuth: (admin) =>
        set({
          admin,
          isAuthenticated: true,
        }),

      updateAdmin: (patch) =>
        set((state) => ({
          admin: state.admin ? { ...state.admin, ...patch } : state.admin,
        })),

      logout: () =>
        set({
          admin: null,
          isAuthenticated: false,
        }),
    }),
    {
      // هاردکد شده برای جلوگیری از خطای ایمپورت
      name: "khooban-admin-auth",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        admin: state.admin,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);